import axios from 'axios';

// Bearer token для Glovo API
const GLOVO_API_TOKEN = '5bf8f92a-4f0a-4baa-9618-eca6a4b5f8ec';

// URL для різних середовищ
const GLOVO_API_URLS = {
  production: 'https://menu-tool.glovoapp.com/partners/api',
  test: 'https://menu-tool.glovoapp.com/partners-api/api',
};

// Поточне середовище (за замовчуванням production)
let currentEnvironment = 'production';

// Функція для створення axios інстансу з відповідним baseURL
const createGlovoHttp = (environment = 'production') => {
  return axios.create({
    baseURL: GLOVO_API_URLS[environment],
    headers: {
      'Authorization': `Bearer ${GLOVO_API_TOKEN}`,
      'Content-Type': 'application/json',
    },
  });
};

// Початковий інстанс
let glovoHttp = createGlovoHttp(currentEnvironment);

// Функція для зміни середовища
export const setEnvironment = (environment) => {
  if (GLOVO_API_URLS[environment]) {
    currentEnvironment = environment;
    glovoHttp = createGlovoHttp(environment);
  }
};

// Функція для отримання поточного середовища
export const getCurrentEnvironment = () => currentEnvironment;

// ============ SUPER COLLECTIONS ============

export const getSuperCollections = (storeAddressId) => {
  return glovoHttp.get(`/menu-supercollections/${storeAddressId}`);
};

export const deleteSuperCollection = (storeAddressId, superCollectionId) => {
  return glovoHttp.delete(`/menu-supercollections/${storeAddressId}/${superCollectionId}`);
};

// ============ COLLECTIONS ============

export const getCollections = (storeAddressId) => {
  return glovoHttp.get(`/menu-collections/${storeAddressId}`);
};

export const deleteCollection = (storeAddressId, collectionId) => {
  return glovoHttp.delete(`/menu-collections/${storeAddressId}/${collectionId}`);
};

// ============ PRODUCTS ============

export const getProducts = (storeAddressId) => {
  return glovoHttp.get(`/products/${storeAddressId}`);
};

export const deleteProduct = (storeAddressId, groupId, productId) => {
  return glovoHttp.delete(`/products/${storeAddressId}/${groupId}/${productId}`);
};

export const deleteProductGroup = (storeAddressId, groupId) => {
  return glovoHttp.delete(`/products/${storeAddressId}/${groupId}`);
};

// ============ OPTIONS ============

export const getOptions = (storeAddressId) => {
  return glovoHttp.get(`/options/${storeAddressId}`);
};

export const deleteOptionGroup = (storeAddressId, groupId) => {
  return glovoHttp.delete(`/options/${storeAddressId}/${groupId}`);
};

export const deleteOption = (storeAddressId, groupId, optionId) => {
  return glovoHttp.delete(`/options/${storeAddressId}/${groupId}/${optionId}`);
};

// ============ CLEAR ALL MENU ============

export const clearAllMenu = (storeAddressId) => {
  return glovoHttp.delete(`/store-addresses/${storeAddressId}/clear-all/data`);
};
